import { Injectable } from '@angular/core';
import {
	IMenuItemPermissions,
	IWidgetPermissions,
	PluginInjectorApplicationPlugin,
  PluginInjectorService
} from 'core-client/api';
import { VmailboxMenuItemService } from './vmailbox/services/vmailbox-menu-item.service';
import { PhoneWidgetAddComponent } from './phone/phone-widget-add/phone-widget-add.component';
import { PhoneWidgetViewComponent } from './phone/phone-widget-view/phone-widget-view.component';
import { PhoneWidgetSettingsComponent } from './phone/phone-widget-settings/phone-widget-settings.component';
import { ContactWidgetAddComponent } from './contact/contact-widget-add/contact-widget-add.component'
import { ContactWidgetViewComponent } from './contact/contact-widget-view/contact-widget-view.component'
import { ContactWidgetSettingsComponent } from './contact/contact-widget-settings/contact-widget-settings.component'
import { VMailboxWidgetAddComponent } from './vmailbox/vmailbox-widget-add/vmailbox-widget-add.component';
import { VMailboxWidgetViewComponent } from './vmailbox/vmailbox-widget-view/vmailbox-widget-view.component';
import { VMailboxWidgetSettingsComponent } from './vmailbox/vmailbox-widget-settings/vmailbox-widget-settings.component';


@Injectable({
  providedIn: "root",
})
export class AstimaxService {
  private readonly plugin: PluginInjectorApplicationPlugin.IApplicationPlugin =
    <PluginInjectorApplicationPlugin.IApplicationPlugin>{};
  private widgetPermissions: IWidgetPermissions = {
    phone: {
      astimax_phone_enabled: false,
      astimax_phone_edit: false,
      astimax_phone_widget_header_display: false,
    },
    contact: {
      astimax_contact_enabled: false,
      astimax_contact_settings_edit: false,
      astimax_contact_widget_header_display: false,
    },
    vmailbox: {
      astimax_vmailbox_enabled: false,
      astimax_vmailbox_settings_edit: false,
      astimax_vmailbox_widget_header_display: false,
    },
  };

  private menuItemPermissions: IMenuItemPermissions = {
    vmailbox: {
      astimax_vmailbox_menuitem_enabled: false,
    },
  };

  private readonly PHONE_MODULE = {
    pluginModule: "PHONE",
    pluginId: "",
    widgetPermissions: {
      widgetEnabledPermission: {
        permissionRef: "astimax_phone_enabled",
      },
      widgetBasePermissions: {
        autorizeDisplayOfWidgetHeader: {
          permissionRef: "astimax_phone_widget_header_display",
        },
        widgetSettingsEnabledPermission: {
          permissionRef: "astimax_phone_edit",
        },
      },
    },
    addComponent: {
      title: "#TRANSLATE-LATER#ASTIMAX.PHONE.WIDGET.TITLE",
      componentName: "PhoneWidgetAddComponent",
      component: PhoneWidgetAddComponent,
    },
    viewComponent: {
      title: "Dummy (viewComponent not used yet)",
      componentName: "PhoneWidgetViewComponent",
      component: PhoneWidgetViewComponent,
    },
    settingComponent: {
      componentName: "PhoneWidgetSettingsComponent",
      component: PhoneWidgetSettingsComponent,
      dialogConfig: {
        width: this.pluginInjectorService.getMenuDialogConfig().width,
      },
    },
  };

  private readonly CONTACT_MODULE = {
    pluginModule: "CONTACT",
    pluginId: "",
    widgetPermissions: {
      widgetEnabledPermission: {
        permissionRef: "astimax_contact_enabled",
      },
      widgetBasePermissions: {
        autorizeDisplayOfWidgetHeader: {
          permissionRef: "astimax_contact_widget_header_display",
        },
        widgetSettingsEnabledPermission: {
          permissionRef: "astimax_contact_settings_edit",
        },
      },
    },
    addComponent: {
      title: "#TRANSLATE-LATER#ASTIMAX.CONTACT.WIDGET.TITLE",
      componentName: "ContactWidgetAddComponent",
      component: ContactWidgetAddComponent,
    },
    viewComponent: {
      title: "Dummy (viewComponent not used yet)",
      componentName: "ContactWidgetViewComponent",
      component: ContactWidgetViewComponent,
    },
    settingComponent: {
      componentName: "ContactWidgetSettingsComponent",
      component: ContactWidgetSettingsComponent,
      dialogConfig: {
        width: this.pluginInjectorService.getMenuDialogConfig().width,
      },
    },
  };

  private readonly VMAILBOX_MODULE = {
    pluginModule: "VMAILBOX",
    pluginId: "",
    widgetPermissions: {
      widgetEnabledPermission: {
        permissionRef: "astimax_vmailbox_enabled",
      },
      widgetBasePermissions: {
        autorizeDisplayOfWidgetHeader: {
          permissionRef: "astimax_vmailbox_widget_header_display",
        },
        widgetSettingsEnabledPermission: {
          permissionRef: "astimax_vmailbox_settings_edit",
        },
      },
    },
    addComponent: {
      title: "#TRANSLATE-LATER#ASTIMAX.VMAILBOX.WIDGET.TITLE",
      componentName: "VMailBoxWidgetAddComponent",
      component: VMailboxWidgetAddComponent,
    },
    viewComponent: {
      title: "Dummy (viewComponent not used yet)",
      componentName: "VMailboxWidgetViewComponent",
      component: VMailboxWidgetViewComponent,
    },
    settingComponent: {
      componentName: "VMailboxWidgetSettingsComponent",
      component: VMailboxWidgetSettingsComponent,
      dialogConfig: {
        width: this.pluginInjectorService.getMenuDialogConfig().width,
      },
    },
  };

  private readonly pluginModule: PluginInjectorApplicationPlugin.IPluginModule =
    {
      widgets: [this.PHONE_MODULE, this.CONTACT_MODULE, this.VMAILBOX_MODULE],
    };

  constructor(
    private readonly pluginInjectorService: PluginInjectorService,
    private readonly vmailboxMenuItemService: VmailboxMenuItemService,
  ) {
    this.plugin.name = "ASTIMAX";
    this.plugin.enabled = false;
    this.plugin.description = "Astimax Plugin";
    this.plugin.settings = {
      ice_stun_server_url: "",
      ice_turn_server_url: "",
      ice_turn_username: "",
      ice_turn_password: "",
    };
    this.plugin.permissions = {
      widget_permissions: this.widgetPermissions,
      menuitem_permissions: this.menuItemPermissions,
    };
    this.plugin.menuItems = [];
    this.plugin.modules = [this.pluginModule];
    this.plugin.version = "0.0.1";
  }

  setup(): void {
    this.initPlugin();
  }

  private initPlugin(): void {
    this.addHeaderNavigationMenuItems();
    this.pluginInjectorService.register(this.plugin);
  }

  private addHeaderNavigationMenuItems(): void {
    if (this.plugin.menuItems) {
      this.plugin.menuItems = this.vmailboxMenuItemService.getNavbarMenuItem(
        this.plugin,
        this.plugin.menuItems,
        true,
        false,
      );
    }
  }
}
